export default "__VITE_ASSET__88627111__"